






import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class QueenyTestPage extends Vue {

  created(): void {
    this.$appMgr.log('created: QueenyTestPage');
  }

  mounted(): void {
    this.$appMgr.log('mounted: QueenyTestPage');
  }

  destroyed(): void {
    this.$appMgr.log('destroyed: QueenyTestPage');
  }
}
